// frontend/src/utils/errorUtils.ts

/**
 * Safely extract a message string from an unknown caught error.
 *
 * Replaces the repetitive `(err as Error).message` pattern used across
 * catch blocks. Handles Error objects, strings, and objects with a
 * message property.
 */
export function getErrorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  if (
    err !== null &&
    err !== undefined &&
    typeof err === 'object' &&
    'message' in err &&
    typeof (err as { message: unknown }).message === 'string'
  ) {
    return (err as { message: string }).message;
  }
  return 'An unexpected error occurred';
}
